import { Link } from "@tanstack/react-router";
import { AlertTriangle } from "lucide-react";
import { useAppSettings } from "@/hooks/use-app-settings";

/**
 * Said where somebody wondering why an email never arrived will actually be
 * looking — the switch itself lives under Config → Email testing, and a
 * diversion nobody remembers turning on looks exactly like a broken pipeline.
 * Shown on Settings → Logs → Email and on Config → Notification Templates.
 */
export function TestEmailNotice({ context = "log" }: { context?: "log" | "templates" }) {
  const { data } = useAppSettings();
  if (!data?.testEmailEnabled || !data.testEmailAddress) return null;

  return (
    <div className="flex items-start gap-3 rounded-lg border border-warning/40 bg-warning/10 p-4">
      <AlertTriangle className="mt-0.5 size-4 shrink-0 text-warning-foreground" aria-hidden />
      <div className="text-sm">
        <p className="font-medium">Email testing is on — nothing is reaching its recipients</p>
        <p className="text-muted-foreground">
          {context === "templates" ? (
            <>
              While it's on, every email the app sends, including these, goes to{" "}
              <strong>{data.testEmailAddress}</strong> instead of the people it's addressed to.
            </>
          ) : (
            <>
              Every email below went to <strong>{data.testEmailAddress}</strong> instead of the
              people it was addressed to.
            </>
          )}{" "}
          <Link to="/dashboard/settings/config/email-testing" className="underline">
            Turn it off
          </Link>{" "}
          when you have finished testing.
        </p>
      </div>
    </div>
  );
}
